import { render } from "./NotificationInternalPay.vue?vue&type=template&id=a2c626ae&scoped=true"
import script from "./NotificationInternalPay.vue?vue&type=script&lang=js"
export * from "./NotificationInternalPay.vue?vue&type=script&lang=js"

import "./NotificationInternalPay.vue?vue&type=style&index=0&id=a2c626ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c626ae"]])

export default __exports__